<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Main Banner</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'link'"
            [blockData]="block.variables?.['MainBannerImageDesktop'] ?? ''"
            (handleOnChange)="onChange($event, 'MainBannerImageDesktop')"
            [placeholder]="imageDesktopPlaceholder"
            variable="MainBannerImageDesktop"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            [maxLength]="500"
            [blockData]="block.variables?.['MainBannerImageMobile'] ?? ''"
            (handleOnChange)="onChange($event, 'MainBannerImageMobile')"
            [placeholder]="imageMobilePlaceholder"
            variable="MainBannerImageMobile"
            [isImage]="true"
            [blockId]="block.blockId"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'alt'"
            [maxLength]="500"
            [blockData]="block.variables?.['MainBannerAlt'] ?? ''"
            (handleOnChange)="onChange($event, 'MainBannerAlt')"
            variable="MainBannerAlt"
            [placeholder]="altPlaceholder"
          >
          </app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            [blockData]="block.variables?.['MainBannerHref'] ?? ''"
            (handleOnChange)="onChange($event, 'MainBannerHref')"
            [placeholder]="hrefPlaceholder"
            variable="MainBannerHref"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'MainBannerHrefSegmentRegex')"
            [selectedSegment]="block.variables?.MainBannerHrefSegmentRegex ?? ''"
          >
          </app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row">
          <div
            *ngIf="block.variables?.['MainBannerImageDesktop']"
            class="row col-12"
          >
            <span>Image desktop</span>
            <a
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.['MainBannerHref']))"
              target="_blank"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.['MainBannerImageDesktop'])"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.['MainBannerAlt'])"
              />
            </a>
          </div>

          <div
            *ngIf="block.variables?.['MainBannerImageMobile']"
            class="row col-12 mt-2"
          >
            <span>Image mobile</span>
            <a
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.['MainBannerHref']))"
              target="_blank"
            >
              <img
                [src]="$safeNavigationMigration(block.variables?.['MainBannerImageMobile'])"
                class="img-fluid"
                [alt]="$safeNavigationMigration(block.variables?.['MainBannerAlt'])"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
